import { ReactComponent as ArrowLeft } from "./icon-sources/arrow-left.svg";
import { ReactComponent as ArrowRight } from "./icon-sources/arrow-right.svg";
import { ReactComponent as Attachment } from "./icon-sources/attachment.svg";
import { ReactComponent as BiessePin } from "./icon-sources/biesse-pin.svg";
import { ReactComponent as CalendarCheck } from "./icon-sources/calendar-check.svg";
import { ReactComponent as CheckCircle } from "./icon-sources/check-circle.svg";
import { ReactComponent as Check } from "./icon-sources/check.svg";
import { ReactComponent as CheckboxCheck } from "./icon-sources/checkbox-check.svg";
import { ReactComponent as ChevronLeft } from "./icon-sources/chevron-left.svg";
import { ReactComponent as ChevronRight } from "./icon-sources/chevron-right.svg";
import { ReactComponent as ChevronUpThick } from "./icon-sources/chevron-up-thick.svg";
import { ReactComponent as ChevronUp } from "./icon-sources/chevron-up.svg";
import { ReactComponent as CirclePlus } from "./icon-sources/circle-plus.svg";
import { ReactComponent as Clock } from "./icon-sources/clock.svg";
import { ReactComponent as CloseCircle } from "./icon-sources/close-circle.svg";
import { ReactComponent as Close } from "./icon-sources/close.svg";
import { ReactComponent as Crosshair } from "./icon-sources/crosshair.svg";
import { ReactComponent as Directions } from "./icon-sources/directions.svg";
import { ReactComponent as Download } from "./icon-sources/download.svg";
import { ReactComponent as EyeHide } from "./icon-sources/eye-hide.svg";
import { ReactComponent as Eye } from "./icon-sources/eye.svg";
import { ReactComponent as Facebook } from "./icon-sources/fb.svg";
import { ReactComponent as Filter } from "./icon-sources/filter.svg";
import { ReactComponent as Hamburger } from "./icon-sources/hamburger.svg";
import { ReactComponent as Linkedin } from "./icon-sources/in.svg";
import { ReactComponent as InfoOutline } from "./icon-sources/info-outline.svg";
import { ReactComponent as Info } from "./icon-sources/info.svg";
import { ReactComponent as Instagram } from "./icon-sources/inst.svg";
import { ReactComponent as Link } from "./icon-sources/link.svg";
import { ReactComponent as Logout } from "./icon-sources/logout.svg";
import { ReactComponent as LongArrowDown } from "./icon-sources/long-arrow-down.svg";
import { ReactComponent as MapPin } from "./icon-sources/map-pin.svg";
import { ReactComponent as Pencil } from "./icon-sources/pencil.svg";
import { ReactComponent as ProfileEdit } from "./icon-sources/profile-edit.svg";
import { ReactComponent as Profile } from "./icon-sources/profile.svg";
import { ReactComponent as Search } from "./icon-sources/search.svg";
import { ReactComponent as Share } from "./icon-sources/share.svg";
import { ReactComponent as World } from "./icon-sources/world.svg";
import { ReactComponent as Wrench } from "./icon-sources/wrench.svg";
import { ReactComponent as Youtube } from "./icon-sources/yt.svg";
import { ReactComponent as ZoomIn } from "./icon-sources/zoom-in.svg";

export const iconsMap = {
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "chevron-up": ChevronUp,
  "chevron-up-thick": ChevronUpThick,
  "long-arrow-down": LongArrowDown,
  "checkbox-check": CheckboxCheck,
  "info-outline": InfoOutline,
  "eye-hide": EyeHide,
  "check-circle": CheckCircle,
  "close-circle": CloseCircle,
  "zoom-in": ZoomIn,
  "circle-plus": CirclePlus,
  attachment: Attachment,
  download: Download,
  eye: Eye,
  pencil: Pencil,
  share: Share,
  wrench: Wrench,
  facebook: Facebook,
  linkedin: Linkedin,
  instagram: Instagram,
  youtube: Youtube,
  link: Link,
  check: Check,
  close: Close,
  search: Search,
  info: Info,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  filter: Filter,
  "map-pin": MapPin,
  clock: Clock,
  profile: Profile,
  hamburger: Hamburger,
  world: World,
  logout: Logout,
  "profile-edit": ProfileEdit,
  "calendar-check": CalendarCheck,
  directions: Directions,
  "biesse-pin": BiessePin,
  crosshair: Crosshair,
};

export type IconName = keyof typeof iconsMap;
